import React, { useEffect, useState } from 'react'
import './App.css'
import './Zoom.css'
import { Redirect } from 'react-router-dom'
import Axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import { IoIosArrowBack } from 'react-icons/io'
import {
  IoTicketOutline,
  IoCalendarOutline,
  IoTimeOutline,
  IoLocationOutline,
  IoInformationCircleOutline,
  IoWarningOutline,
  IoShieldCheckmarkOutline,
} from 'react-icons/io5'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import Header from './layouts/Header'
import TicketActionModal from './modals/ticket/TicketActionModal'
import { API_URL } from './config'

var QRCode = require('qrcode.react')

const Zoom = () => {
  const history = useHistory()
  const location = useLocation()
  const {
    transactiondate,
    venue,
    eventtime,
    eventday,
    yearcreated,
    theme,
    admissions,
    totalcost,
    ticketnumber,
    eventid,
    refund_status,
    eventname,
  } = location.state

  const [qrPayload, setQrPayload] = useState('')
  const [loading, setLoading] = useState(true)
  const [holderDisabled, setHolderDisabled] = useState(false)
  const [modalAction, setModalAction] = useState(null)
  const [modalError, setModalError] = useState('')
  const [busy, setBusy] = useState(false)
  const [notice, setNotice] = useState(null)

  const customername = localStorage.getItem('customername')
  const customerid = localStorage.getItem('customerid')
  document.title = customername
  const baseURL = `${API_URL}/apps/kscanner/webservices.php`

  useEffect(() => {
    Axios.get(
      baseURL +
        '?query=ZOOM-IN-TICKET&customerid=' +
        customerid +
        '&eventid=' +
        eventid +
        '&ticket_number=' +
        ticketnumber,
      {
        withCredentials: true,
      },
    )
      .then((response) => {
        setQrPayload(response.data.qr_payload ?? '')
        setHolderDisabled(Number(response.data.holder_disabled) === 1)
        setTimeout(() => {
          setLoading(false)
        }, 1000)
      })
      .catch((error) => console.log(error))
  }, [])

  const openModal = (action) => {
    setModalError('')
    setModalAction(action)
  }

  const closeModal = () => {
    if (!busy) setModalAction(null)
  }

  const toggleTicket = (action, password) => {
    setBusy(true)
    setModalError('')
    const data = new FormData()
    data.append('query', action === 'enable' ? 'ENABLE-TICKET' : 'DISABLE-TICKET')
    data.append('eventid', eventid)
    data.append('ticket_number', ticketnumber)
    if (password) data.append('password', password)

    Axios.post(baseURL, data, {
      withCredentials: true,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((response) => {
        setBusy(false)
        if (response.data.status === 'failed') {
          setModalError(response.data.message)
          return
        }
        setModalAction(null)
        setHolderDisabled(action === 'disable')
        if (action === 'enable') {
          setQrPayload(response.data.qr_payload ?? '')
        }
        setNotice({
          type: 'info',
          text:
            action === 'disable'
              ? 'Ticket disabled.'
              : 'Ticket enabled. Your QR code has been refreshed, so any older copy stays invalid.',
        })
      })
      .catch(() => {
        setBusy(false)
        setModalError('Something went wrong. Please try again.')
      })
  }

  if (localStorage.getItem('customername') === null) {
    return <Redirect to="/login" />
  }

  const isVoid =
    refund_status === 'Pending' || refund_status === 'Under_review' || refund_status === 'Approved'
  const isOff = isVoid || holderDisabled

  return (
    <div className="view">
      <Header />

      <main className="zm-page" style={{ marginTop: 'var(--header-h)' }}>
        <div className="zm-container">
          <div className="zm-top">
            <button type="button" className="zm-back" onClick={() => history.goBack()}>
              <IoIosArrowBack size={18} />
              <span>Back</span>
            </button>

            <span className="zm-chip">
              <IoTicketOutline size={14} />
              {ticketnumber}
            </span>
          </div>

          {loading ? (
            <section className="zm-card zm-card--loading">
              <ClipLoader size={25} color="grey" />
            </section>
          ) : (
            <section className="zm-card">
              <div className="zm-head">
                {refund_status === 'Pending' ? (
                  <div className="zm-note zm-note--info">
                    <IoInformationCircleOutline size={18} />
                    <span>Refund request submitted. Awaiting review.</span>
                  </div>
                ) : refund_status === 'Under_review' ? (
                  <div className="zm-note zm-note--info">
                    <IoInformationCircleOutline size={18} />
                    <span>
                      Refund request under review. We'll notify you once a decision is made.
                    </span>
                  </div>
                ) : refund_status === 'Approved' ? (
                  <div className="zm-note zm-note--warn">
                    <IoInformationCircleOutline size={18} />
                    <span>This ticket has been refunded and is no longer valid.</span>
                  </div>
                ) : holderDisabled ? (
                  <div className="zm-note zm-note--warn">
                    <IoWarningOutline size={18} />
                    <span>
                      You disabled this ticket. Enable it when you reach the entrance to get a fresh
                      QR code.
                    </span>
                  </div>
                ) : (
                  <h1 className="zm-title">
                    Show this Karamale QR code at the entrance to unlock the moment.
                  </h1>
                )}

                {notice && (
                  <div className={`zm-note zm-note--${notice.type}`}>
                    <IoInformationCircleOutline size={18} />
                    <span>{notice.text}</span>
                  </div>
                )}
              </div>

              <div className="zm-body">
                {qrPayload === '' && !holderDisabled ? (
                  <div className="zm-invalid">🚫 This QR code is invalid</div>
                ) : (
                  ''
                )}

                {refund_status === 'Under_review' || refund_status === 'Pending' ? (
                  <div className="zm-status">Ticket temporarily disabled</div>
                ) : refund_status === 'Approved' ? (
                  <div className="zm-status">This ticket is no longer valid</div>
                ) : holderDisabled ? (
                  <div className="zm-status">Ticket disabled</div>
                ) : (
                  ''
                )}

                <div className={`zm-qr ${isOff ? 'zm-qr--void' : ''}`}>
                  <QRCode
                    value={holderDisabled ? 'disabled' : qrPayload}
                    logoSize={30}
                    size={250}
                    fgColor={isOff ? '#dcdcdc' : '#000'}
                    bgColor="#fff"
                  />
                </div>

                {!isVoid &&
                  (holderDisabled ? (
                    <button
                      type="button"
                      className="zm-report zm-report--enable"
                      onClick={() => openModal('enable')}
                    >
                      <IoShieldCheckmarkOutline size={14} /> Enable ticket
                    </button>
                  ) : (
                    qrPayload !== '' && (
                      <button
                        type="button"
                        className="zm-report"
                        onClick={() => openModal('disable')}
                      >
                        <IoWarningOutline size={14} /> Think this QR was copied? Disable ticket
                      </button>
                    )
                  ))}
              </div>

              {!isVoid && (
                <div className="zm-help">
                  <div className="zm-help__item">
                    <strong>When to disable</strong>
                    <span>
                      Disable your ticket if you think someone copied your QR code, if you sent your
                      ticket to someone by mistake, or if you shared a screenshot of it. Anyone
                      scanning a disabled ticket at the gate will be turned away.
                    </span>
                  </div>
                  <div className="zm-help__item">
                    <strong>When you can enable it again</strong>
                    <span>
                      Enable it when you arrive at the entrance and are ready to be scanned. You'll
                      need your password, and you'll get a fresh QR code. Any older copy stops
                      working for good. You can't disable a ticket that has already been scanned in.
                    </span>
                  </div>
                </div>
              )}

              {(eventname || eventday || eventtime || venue) && (
                <div className="zm-event">
                  {eventname && <div className="zm-event__name">{eventname}</div>}

                  <div className="zm-event__meta">
                    {eventday && (
                      <span>
                        <IoCalendarOutline /> {eventday}
                      </span>
                    )}
                    {eventtime && (
                      <span>
                        <IoTimeOutline /> {eventtime}
                      </span>
                    )}
                    {venue && (
                      <span>
                        <IoLocationOutline /> {venue}
                      </span>
                    )}
                  </div>
                </div>
              )}
            </section>
          )}
        </div>
      </main>

      <TicketActionModal
        action={modalAction}
        ticketNumber={ticketnumber}
        busy={busy}
        error={modalError}
        onConfirm={(pw) => toggleTicket(modalAction, pw)}
        onCancel={closeModal}
      />
    </div>
  )
}

export default Zoom
